var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-pen",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.715,2.99c1.421,-1.42 3.724,-1.42 5.145,0c1.42,1.421 1.42,3.724 -0,5.145l-12.292,12.291c-0.346,0.347 -0.526,0.512 -0.725,0.644c-0.216,0.142 -0.45,0.255 -0.696,0.334c-0.228,0.074 -0.47,0.111 -0.956,0.165l-3.15,0.35c-0.304,0.033 -0.605,-0.072 -0.822,-0.288c-0.216,-0.217 -0.321,-0.519 -0.288,-0.822l0.35,-3.15c0.054,-0.487 0.091,-0.728 0.165,-0.956c0.079,-0.246 0.192,-0.48 0.335,-0.695c0.131,-0.199 0.296,-0.379 0.643,-0.726l12.291,-12.292Zm-0.66,3.503c0,0 2.302,2.302 2.302,2.302l2.081,-2.082c0.636,-0.635 0.636,-1.666 0,-2.301c-0.635,-0.636 -1.666,-0.636 -2.301,-0l-2.082,2.081Zm0.88,3.723c0,0 -2.301,-2.301 -2.301,-2.301l-8.789,8.788c-0.201,0.202 -0.31,0.295 -0.386,0.412c-0.043,0.064 -0.076,0.134 -0.1,0.207c-0.043,0.133 -0.048,0.276 -0.08,0.559l-0.211,1.901l1.901,-0.211c0.283,-0.032 0.426,-0.037 0.559,-0.08c0.073,-0.024 0.143,-0.057 0.207,-0.099c0.116,-0.077 0.21,-0.186 0.412,-0.387l8.788,-8.789Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBPen);
export default __webpack_public_path__ + "static/media/iconB-pen.db4a8a76f524fe3da8e811dad7566c3a.svg";
export { ForwardRef as ReactComponent };